import React from "react";
import PropTypes from 'prop-types';
import Backdrop from "./Backdrop";
import styles from './modal.module.css';
import Button from "../button";
import { icons } from "assets";
import Text from "../text";

/**
 * 
 * @param {light | dark} variant specify the background opacity 
 * @param {true | false} padding specify if user will specify its own padding 
 * @param {string | JSX} heading specify the heading and an optional Cancel event
 * @param {sm | md | lg} maxWidth specify the maxWidth
 */
const Modal = ({variant="light", children, onClose,className,
        padding=true,heading, disableBackdropClick, unmountOnExit,open, maxWidth="sm",...props}) => {
    if(unmountOnExit && !open) return null;
    return (
        <Backdrop dark={variant=="dark"} onClick={disableBackdropClick?null : onClose} open={open}>
            <div className={`${styles.Modal} ${padding? styles.padding : ""} ${className || ""}`} {...props}>
                {heading && (
                    <div className={`${styles.heading} ${!padding ? "modal-padding":""}`} style={{paddingBottom: '2rem'}}>
                        <Text variant="lg" style={{fontWeight: '600'}}>{heading}</Text>
                        {onClose && (<Button variant="empty" style={{paddingRight:0, flexGrow:0}}
                        onClick={(e) => {e.stopPropagation(); onClose(e)}}>
                            <img src={icons.cross} alt="cancel action" />
                        </Button>)}
                    </div>
                )}
                {children}
            </div>
        </Backdrop>
    )
}

Modal.propTypes = {
    variant: PropTypes.string,
    padding:PropTypes.bool,
    heading:PropTypes.node
}
export default Modal;